import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../lib/AuthContext';
import { hasAdminAccess, hasManagementAccess } from '../../lib/permissions';

interface AdminProtectedRouteProps {
  children: React.ReactNode;
  /**
   * When true, managers are also allowed in (in addition to admins/HR).
   * The rendered page is responsible for scoping content to the manager's
   * own direct reports.
   */
  allowManagers?: boolean;
}

const AdminProtectedRoute: React.FC<AdminProtectedRouteProps> = ({ children, allowManagers = false }) => {
  const { currentUser, userProfile } = useAuth();

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // Admin-level access:
  // - Super admins (by email)
  // - Users with admin role
  // - Users with HR flag
  // When allowManagers is set, managers (role === 'manager') are also permitted.
  const allowed = allowManagers
    ? hasManagementAccess(currentUser.email, userProfile)
    : hasAdminAccess(currentUser.email, userProfile);

  if (!allowed) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default AdminProtectedRoute;
